import path from 'ramda/es/path';
// DEPRECATED
export const errorCode = path(['response', 'status']); // eslint-disable-line import/prefer-default-export
